import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class SupportService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Add support user to organization
     * @returns void
     * @throws ApiError
     */
    addSupportToOrganization({ orgId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/support-users', path: {
                'orgId': orgId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Update support user role in organization
     * @returns void
     * @throws ApiError
     */
    updateSupportRoleInOrganization({ orgId, requestBody, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PATCH', url: '/orgs/{orgId}/support-users', path: {
                'orgId': orgId,
            }, body: requestBody, mediaType: 'application/json', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Delete support user from organization
     * @returns void
     * @throws ApiError
     */
    deleteSupportFromOrganization({ orgId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'DELETE', url: '/orgs/{orgId}/support-users', path: {
                'orgId': orgId,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * List Paying Subscriptions Stats
     * @returns SubscriptionStatsList OK.
     * @throws ApiError
     */
    subscriptionsStatsPaying({ sort = '-id', filter, limit = 10, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/subscriptions-stats-paying', query: {
                'sort': sort,
                'filter': filter,
                'limit': limit,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * List Subscriptions Stats
     * @returns SubscriptionStatsList OK.
     * @throws ApiError
     */
    subscriptionsStats({ sort = '-id', filter, limit = 10, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/subscriptions-stats', query: {
                'sort': sort,
                'filter': filter,
                'limit': limit,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * List Subscriptions Leads Stats
     * @returns SubscriptionStatsLeadsList OK.
     * @throws ApiError
     */
    subscriptionsStatsLeadsList({ sort = '-id', filter, limit = 10, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/subscriptions-stats-leads', query: {
                'sort': sort,
                'filter': filter,
                'limit': limit,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * List Conversion Paying Leads Stats
     * @returns SubscriptionStatsLeadsList OK.
     * @throws ApiError
     */
    subscriptionsStatsPayingLeadsList({ sort = '-id', filter, limit = 10, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/subscriptions-stats-paying-leads', query: {
                'sort': sort,
                'filter': filter,
                'limit': limit,
            }, errors: {
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=SupportService.js.map